// src/pages/EdgeNodes.jsx

import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import EdgeNodesList from '../components/edge-nodes/EdgeNodesList';
import EdgeNodeDetail from '../components/edge-nodes/EdgeNodeDetail';
import EdgeNodeRegistration from '../components/edge-nodes/EdgeNodeRegistration';
// NEW, CORRECTED IMPORT
import EdgeNodeForm from '../components/edge-nodes/EdgeNodeForm.jsx';

const EdgeNodes = () => {
  const [filters, setFilters] = useState({
    status: ''
  });
  const location = useLocation();
  
  const showFilters = location.pathname === '/edge-nodes';

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({ status: '' });
  };

  return (
    <div>
      <div className="px-4 py-5 sm:px-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
              Edge Nodes
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Manage your Celerway AI Sentry edge nodes and gateways.
            </p>
          </div>
          {showFilters && (
            <Link
              to="/edge-nodes/register" // This can be changed to `/edge-nodes/new` for consistency if you like
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <svg className="mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              Register New Edge Node
            </Link>
          )}
        </div>
      </div>
      
      {showFilters && (
        <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mb-6">
          {/* ... No changes to filters ... */}
          <div className="md:flex md:items-center">
            <div className="md:w-1/4">
              <label htmlFor="status" className="block text-sm font-medium text-gray-700">Status</label>
              <select id="status" name="status" value={filters.status} onChange={handleFilterChange} className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                <option value="">All Statuses</option>
                <option value="Online">Online</option>
                <option value="Offline">Offline</option>
              </select>
            </div>
            <div className="mt-4 md:mt-0 md:ml-6 md:flex-shrink-0">
              <button type="button" onClick={resetFilters} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50">
                Reset Filters
              </button>
            </div>
          </div>
        </div>
      )}
      
      <Routes>
        <Route index element={<EdgeNodesList filters={filters} />} />
        <Route path=":nodeId" element={<EdgeNodeDetail />} />
        <Route path="register" element={<EdgeNodeRegistration />} />

        {/* *** 2. ADD THE NEW ROUTE FOR THE EDIT PAGE *** */}
        {/* This tells React: when the URL is /edge-nodes/{some-id}/edit, render the EdgeNodeForm */}
        <Route path=":nodeId/edit" element={<EdgeNodeForm mode="edit" />} />

      </Routes>
    </div>
  );
};

export default EdgeNodes;
